module.exports = __webpack_public_path__ + "img/home.3ec95c17.gif";